import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToHash = () => {
	const location = useLocation();

	useEffect(
		() => {
			if (location.hash) {
				setTimeout(() => {
					const id = location.hash.replace('#', '');
					const element = document.getElementById(id);
					if (element) {
						element.scrollIntoView({ behavior: 'smooth' });
					}
				}, 0);
			}
		},
		[location]
	);
};

export default useScrollToHash;
